// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1F-1H","placeholdersHeader":"styles_placeholdersHeader__1R4HP","editorStyle":"styles_editorStyle__3gDIs","placeholdersBox":"styles_placeholdersBox__1UQKV"};